import { FilterPreference } from './filter-preference';
import { FilterQueryParams } from './filter-query-params';
import { DashboardPreference } from '../dashboards/dashboard-preference';

export function toFilterQueryParams(queryParam: DashboardPreference | FilterPreference | undefined): FilterQueryParams {
    return {
        startDate: queryParam?.startDate,
        endDate: queryParam?.endDate,
        activeDate: queryParam?.activeDate,
        funds: queryParam?.funds,
        timestamp: (queryParam as FilterPreference)?.timestamp, // only on FilterPreference
        clients: queryParam?.clients,
        acknowledged: (queryParam as DashboardPreference)?.acknowledged, // only on DashboardPreference
        isPreferenceChangedOnRefresh: (queryParam as DashboardPreference)?.isPreferenceChangedOnRefresh, // only on DashboardPreference
        // for net-settlement, we have no reason to stash this on the dashboard preference as we never save the state
        includeManuallyReleased: (queryParam as DashboardPreference)?.includeManuallyReleased, // only relevant for net-settlement breaks
        additionalFilters: queryParam?.additionalFilters,
    };
}
